function digitsOnly(str: string): string {
  return str.replace(/\D/g, '');
}

export function clean(
  str: string | null,
  min: number,
  max: number,
  digits: number = 2,
): number | null {
  if (!str) return null;
  const decimalPointIdx = str.indexOf('.');
  const signIdx = str.indexOf('-');
  const cleanedString: string =
    (signIdx > -1 ? '-' : '') +
    (decimalPointIdx > -1
      ? digitsOnly(str.substring(0, decimalPointIdx)) +
        '.' +
        digitsOnly(str.substring(decimalPointIdx + 1))
      : digitsOnly(str));
  if (
    cleanedString === '.' ||
    cleanedString === '-' ||
    cleanedString === '-.'
  ) {
    return null;
  }
  const cleaned = Number(Number(cleanedString).toFixed(digits));
  return Math.max(min, Math.min(max, cleaned));
}
